import { useRef } from 'react'

import { IS_TOUCH } from '../../config/touch'
import { touchMove } from '../../store/uiStore'

// ============================================================
// Joystick virtuale (solo touch), in basso a sinistra: il pomello
// segue il dito entro il raggio e scrive touchMove.x/y (-1..1),
// letti dal Player a ogni frame. Spinto a fondo = corsa.
// ============================================================

const RADIUS = 52 // corsa massima del pomello, in px

export default function TouchJoystick() {
  const knobRef = useRef()
  const origin = useRef(null)

  if (!IS_TOUCH) return null

  const setKnob = (dx, dy) => {
    if (knobRef.current) knobRef.current.style.transform = `translate(${dx}px, ${dy}px)`
  }

  const onDown = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId)
    origin.current = [e.clientX, e.clientY]
  }
  const onMove = (e) => {
    if (!origin.current) return
    let dx = e.clientX - origin.current[0]
    let dy = e.clientY - origin.current[1]
    const mag = Math.hypot(dx, dy)
    if (mag > RADIUS) {
      dx *= RADIUS / mag
      dy *= RADIUS / mag
    }
    touchMove.x = dx / RADIUS
    touchMove.y = dy / RADIUS
    setKnob(dx, dy)
  }
  const onUp = () => {
    origin.current = null
    touchMove.x = 0
    touchMove.y = 0
    setKnob(0, 0)
  }

  return (
    <div
      className="joystick"
      onPointerDown={onDown}
      onPointerMove={onMove}
      onPointerUp={onUp}
      onPointerCancel={onUp}
    >
      <div className="joystick-knob" ref={knobRef} />
    </div>
  )
}
